import React, { createContext, useContext } from 'react';
type Locale = 'ar' | 'us';
const LocaleContext = createContext<Locale>('ar');
export function LocaleProvider({
  locale,
  children
}: {
  locale: Locale;
  children: React.ReactNode;
}) {
  return <LocaleContext.Provider value={locale} data-id="element-439">{children}</LocaleContext.Provider>;
}
export function useLocale() {
  return useContext(LocaleContext);
}